var map = {
	"./account-center-tab.png": 1571,
	"./account-center.png": 1572,
	"./billing-tab.png": 1573,
	"./billing.png": 1574,
	"./calendar-tab.png": 1575,
	"./calendar.png": 1576,
	"./dashboard-tab.png": 1577,
	"./dashboard.png": 1578,
	"./feedback-tab.png": 1579,
	"./feedback.png": 1580,
	"./group.png": 1581,
	"./invoice.png": 1582,
	"./log-out-tab.png": 1583,
	"./log-out.png": 1584,
	"./mag-directory.png": 1585,
	"./my-details-tab.png": 1586,
	"./my-details.png": 1587,
	"./notification-tab.png": 1588,
	"./notification.png": 1589,
	"./report-center-tab.png": 1590,
	"./report-centre.png": 1591,
	"./revoke-tab.png": 1592,
	"./revoke.png": 1593,
	"./search-tab.png": 1594,
	"./search.png": 1595,
	"./service-center-tab.png": 1596,
	"./service-center.png": 1597,
	"./value-settings-tab.png": 1598,
	"./value-settings.png": 1599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1570;